<interacta-radio-group [(ngModel)]="selectedLink">
    @for (link of mappedInverseLink(); track $index) {
        @if (link.linkedBy.postLinkFieldDefinitions) {
            <interacta-radio-button [value]="link">
                {{ link.linkedBy.postLinkFieldDefinitions[0].label }}
            </interacta-radio-button>
        }
    }
</interacta-radio-group>
<interacta-dialog-buttons>
    <button
        interacta-dialog-button
        type="button"
        [label]="'RELATIONS_DIALOG.BACK_BUTTON' | translate"
        [style]="'text'"
        (click)="back.emit()"
    ></button>
    <button
        interacta-dialog-button
        type="button"
        [disabled]="selectedLink == null"
        [label]="'RELATIONS_DIALOG.FIELD.SUBMIT' | translate"
        [style]="'filled'"
        (click)="selectedLink && selectLink.emit({ link: selectedLink })"
    ></button>
</interacta-dialog-buttons>
